'use client'

import { useEffect } from 'react'
import { isTelemetryAllowed, onConsentGranted } from '@/lib/consent/client'
import { acquisitionCookie, acquisitionFromReferrer } from '@/lib/acquisition-source'

/**
 * FRIDGE-1223: records which platform this visit came from, so a later
 * click-out can be attributed. Consent-gated exactly like PostHog: written at
 * once where telemetry is allowed, otherwise only after the visitor allows it.
 * Production host only, matching app/posthog-pageview.tsx.
 */
export default function AcquisitionSourceCookie() {
  useEffect(() => {
    if (window.location.hostname !== 'fridge.com') return
    const source = acquisitionFromReferrer(document.referrer)
    if (!source) return
    const write = () => {
      document.cookie = acquisitionCookie(source, window.location.protocol === 'https:')
    }
    if (isTelemetryAllowed()) {
      write()
      return
    }
    return onConsentGranted(write)
  }, [])

  return null
}
